export default __webpack_public_path__ + "static/media/04__o_preview_5.1ca33290.jpg";